<script lang="ts">
    import {definedMessageService} from './services';
    import LoadingDiv from './LoadingDiv.svelte';
    import type {DefinedMessage, DefinedMessageType} from './types';

    export let type: DefinedMessageType;

    const definedMessagePromise: Promise<DefinedMessage> = definedMessageService.getPrimaryOfType(type);

    function enhanceHtml(html: string) {
        // make all links opened in new window
        return html.replace(/<a\s+href=/gi, '<a target="_blank" href=');
    }
</script>

<div class="defined-message-container">
    {#await definedMessagePromise}
        <LoadingDiv design="calm" />
    {:then definedMessage}
        <div class="defined-message-content">
            {#if definedMessage.html}
                {@html enhanceHtml(definedMessage.text)}
            {:else}
                {definedMessage.text}
            {/if}
        </div>
    {/await}
</div>

<style lang="scss">
  /****** must be global because of @html **/
  :global {
    .defined-message-content {
      td {
        text-align: left;
      }
    }
  }
</style>